var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWindow = function SvgWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.083 16.667C7.083 9.779 12.85 3.75 20 3.75c7.15 0 12.917 6.029 12.917 12.917v16.666A2.916 2.916 0 0 1 30 36.25H10a2.917 2.917 0 0 1-2.917-2.917V16.667ZM21.25 33.75H30a.417.417 0 0 0 .417-.417V22.917H21.25V33.75Zm-2.5-10.833V33.75H10a.417.417 0 0 1-.417-.417V22.917h9.167Zm2.5-2.5h9.167v-3.75c0-5.131-4.016-9.694-9.167-10.34v14.09Zm-2.5-14.09v14.09H9.583v-3.75c0-5.131 4.015-9.694 9.167-10.34Z",
    clipRule: "evenodd"
  })));
};
export default SvgWindow;